import { reloadAppIfExpired } from '~/utils/TokenRefresher';

export default defineNuxtPlugin(() => {
    useGqlError((err: { statusCode: number }) => {
        reloadAppIfExpired(err.statusCode);
    });
});
